import { LOAD_FILE } from '../constants/ActionTypes'

export const createFileAction = ({ slug, types, data = {}, ...extras }) => {
  return {
    [LOAD_FILE]: {
      slug,
      types,
      data,
      ...extras,
    },
  }
}
